import Context from "context/appContext"
import { useContext } from "react"

export default function QuoteNumberTitle() {
    const { policyNumber } = useContext(Context);
    return (
        <>
            <h2 className='question-container__steps-title'>
                Número de cotización: {policyNumber}
            </h2>
        </>
    )
}